<template>
  <div class="scene-canvas">
    <div
      class="scene_title blue_header"
    >
      <!-- 灯带场景信息 -->
      <span>{{ $t("sceneTemplate.sceneEffectPreview") }}</span>
    </div>
    <div class="scene_container">
      <div v-if="hidenUpload !== true" class="scene_container_upload">
        <div class="scene_container_upload-main">
          <p>{{ $t("sceneTemplate.selectImg") }}</p>
          <el-radio-group
            v-model="updateType"
            class="scene_container_bgRadio"
            @input="updateTypeChange"
          >
            <!-- 横向 -->
            <el-radio :label="1">
              {{ $t("sceneTemplate.selectImg") }}
            </el-radio>
            <!-- 纵向 -->
            <el-radio :label="2">
              {{ $t("sceneTemplate.customUpload") }}
            </el-radio>
          </el-radio-group>
          <div
            class="scene_container_bgSelect"
          >
            <ul
              v-if="updateType === 1"
            >
              <li
                v-for="(item, index) in bglist"
                :key="index"
                @click="() => handlerBgChange(index)"
              >
                <div
                  :class="{active: activeBgIndex === index, 'shape-1': shapeType === 1, 'shape-2': shapeType === 2}"
                  class="scene_container_bgSelect_border"
                />
                <img :src="item.img">
                <p>{{ item.text }}</p>
              </li>
            </ul>
            <div
              v-if="updateType === 2"
              class="upload_box"
            >
              <el-upload
                class="avatar-uploader"
                accept="image/*"
                action="xxx"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="onImageChange"
              >
                <img
                  v-if="imageUrl"
                  :src="imageUrl"
                  class="avatar"
                >
                <div
                  v-else
                  class=""
                >
                  <i
                    class="el-icon-plus avatar-uploader-icon"
                  />
                  <p class="avatar-uploader_text">
                    {{ $t('visual.please') }}{{ $t('visual.uploadImg') }} {{ shapeType === 1 ? `${$t('visual.imgSize')} 1000 x 1000px` : '' }}, {{ $t('sceneTemplate.limit') }}
                  </p>
                </div>
              </el-upload>
            </div>
          </div>
        </div>
        <!-- <div class="scene_container_upload-article">
          <div class="scene_container_tip_container">
            <p class="scene_container_tip">
              {{ $t('sync.info') }}
            </p>
            <ul class="scene_container_tip-list">
              <li>1、{{ $t('visual.uploadImg') }}</li>
              <li>2、{{ $t('sceneCard.lightTripCanvasInfo2') }}</li>
              <li>3、{{ $t('sceneCard.lightTripCanvasInfo3') }}</li>
              <li>4、{{ $t('sceneCard.lightTripCanvasInfo4') }}</li>
            </ul>
          </div>
          <ul class="scene_container_tip-info">
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_pencil" />
                <p>{{ $t('sceneCard.lightTripCanvasDraw') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasDrawInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_edit" />
                <p>{{ $t('sceneCard.lightTripCanvasEdit') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasEditInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_delete" />
                <p>{{ $t('sceneCard.lightTripCanvasDelete') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasDeleteInfo') }}
              </p>
            </li>
            <li>
              <div class="scene_container_tip-info_icon">
                <i class="scene-canvas_tool-icon scene-canvas_back" />
                <p>{{ $t('sceneCard.lightTripCanvasBack') }}</p>
              </div>
              <p class="scene_container_tip-info_text">
                {{ $t('sceneCard.lightTripCanvasBackInfo') }}
              </p>
            </li>   
          </ul>
        </div> -->
      </div>
      <div
        v-if="shapeType === 1"
        class="scene_container_info"
      >
        <i class="icon-41" />
        {{ $t('sceneTemplate.noNeedPath') }}
      </div>
      <div class="scene_container_preview">
        <!-- 灯带排列图 -->
        <!-- <p class="upload-preview_title">
          {{ $t("sceneCard.lightTripRankImg") }}:
        </p> -->
        <div class="upload-preview_title" />
        <div
          id="preview_canvas"
          :class="`preview_canvas-shapeType-${shapeType}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DrawCanvas, { MODE_TYPE_ENUMS } from '@/components/DrawCanvas/index';
import { loadAsyncImg } from '@/components/DesignCanvas/index';
import { UploadFile } from "@/axios/ICommon.js";
import { GetImageSenceList } from "@/axios/IFttt.js";

export default {
  components: {},
  inject: [],
  props: {
    hidenUpload: {
      type: Boolean,
      default: false
    },
    checkDeviceList: {
      type: Array,
      default: () => [],
    },
    getFirstDeviceId: {
      type: Function,
      default: () => 0
    },
    onCanvasReady: {
      type: Function,
      default: () => 0
    },
    canvasInitData: {
      type: Object,
      default: null
    },
    shapeType: {
      type: Number,
      default: 1
    },
    from: {
      type: String,
      default: '',
    },
    isTianMu: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      drawCanvasInstance: null,
      imageUrl: '',
      updateType: 1,
      bglist: [],
      activeBgIndex: 0,
      firstDeviceId: null,
      bgListRequestId: 0,
      localImageUrl: ''
    }
  },

  watch: {
    async canvasInitData(data) {
      if (!data) return;

      const requestId = ++this.bgListRequestId;

      this.createDrawCanvas(null, data);

      const res = await GetImageSenceList('matrix_scene_recommend_image');

      if (!this.isAlive || requestId !== this.bgListRequestId) return;

      this.bglist = (res.Result || []).map(item => ({
        text: (item.Name || '').replace(new RegExp(this.$t('scene.WebImageScene') + '\\s?-'), ''),
        img: item.FileUrl
      }))

      const url = (data.bg || {}).url || data.url || data.bg;
      const bgDataIndex = this.bglist.findIndex(item => item.img === url);

      if (bgDataIndex >= 0) {
        this.activeBgIndex = bgDataIndex;
      } else {
        this.activeBgIndex = null;
        this.updateType = 2;
        this.imageUrl = url;
      }

     
    },
  },

  created() {
    this.isAlive = true;
  },

  mounted() {
    
    if (this.from === 'edit' || this.hidenUpload === true) return;

    const { canvasInitData, shapeType } = this;

    // this.bglist = shapeType === 1 ? bgListConfig1 : bgListConfig2;
    // const url = this.bglist[this.activeBgIndex].img; // canvasInitData.bg.url;

    // if (shapeType === 1 && canvasInitData) {
    //   const origin = window.location.origin;
    
    //   this.createDrawCanvas(null, {
    //     ...canvasInitData,
    //     bg: {
    //       ...canvasInitData.bg || {},
    //       url,
    //     },
    //   });
    // } else {
    //   this.createDrawCanvas(null, {
    //     bg: {
    //       url
    //     },
    //   });
    // }

    // this.$emit('imgUpdate', {
    //   bgUrl: url
    // });
  
      
    
    const requestId = ++this.bgListRequestId;

    GetImageSenceList('matrix_scene_recommend_image').then(res => {
      if (!this.isAlive || requestId !== this.bgListRequestId) return;

      this.bglist = (res.Result || []).map(item => ({
        text: (item.Name || '').replace(new RegExp(this.$t('scene.WebImageScene') + '\\s?-'), ''),
        img: item.FileUrl
      }));
      const currentBg = this.bglist[this.activeBgIndex];
      if (!currentBg) return;

      const url = currentBg.img; // canvasInitData.bg.url;

      if (shapeType === 1 && canvasInitData) {
        const origin = window.location.origin;
      
        this.createDrawCanvas(null, {
          ...canvasInitData,
          bg: {
            ...canvasInitData.bg || {},
            url,
          },
        });
      } else {
        this.createDrawCanvas(null, {
          bg: {
            url
          },
        });
      }

      this.$emit('imgUpdate', {
        bgUrl: url
      });
      
    })

    // this.bglist = shapeType === 1 ? bgListConfig1 : bgListConfig2;
  },
  
  beforeDestroy() {
    this.isAlive = false;
    this.bgListRequestId++;
    this.destroyDrawCanvas();

    if (this.localImageUrl) {
      URL.revokeObjectURL(this.localImageUrl);
      this.localImageUrl = '';
    }

    this.bglist = [];
    this.imageUrl = '';
    this.firstDeviceId = null;
  },

  destroyed() {
    if (this.$el && this.$el.__vue__) {
      this.$el.__vue__ = null;
    }
    this._vnode = null;
  },

  methods: {
    destroyDrawCanvas() {
      if (!this.drawCanvasInstance) return;

      this.drawCanvasInstance.removeRegist();
      this.drawCanvasInstance = null;
    },

    updateTypeChange(value) {
      if (this.value === 1) {
        this.imageUrl = '';
      }
    },

    handlerBgChange(index) {
      const lastIndex = this.activeBgIndex;

      this.activeBgIndex =  index;
      const bgData = this.bglist[index];

      this.$emit('imgUpdate', {
        bgUrl: bgData.img,
        title: bgData.text
      });

      if (index === lastIndex || !this.drawCanvasInstance) return;
      
      this.drawCanvasInstance.changeBg({
        initData: {
          bg: {
            width: 400,
            height: 400,
            url: bgData.img,
          },
        }
      });
    },

    // 创建canvas画布组件
    createDrawCanvas(img = null, initData = null, modeType, onReady = null) {
      if (!this.isAlive) return;

      this.destroyDrawCanvas();

      const drawCanvasInstance = new DrawCanvas('#preview_canvas', {
        isTianMu: this.isTianMu,
        originImgData: img,
        // 模式 LINE 线模式 CIRCLE 圆模式
        modeType: 'LINE',
        // 非必传 初始化数据 用于回显
        initData,
        // 非必传 第一个设备的图层id 此处用deviceId关联 不传则默认0
        firstLayerId: (this.checkDeviceList[0] || {}).VDeviceId,
        // 非必传  舞台的参数配置 参考@DrawCanvas/renderOption 默认值
        // stageOption: {}, 
        // 非必传  绘画的参数配置 参考@DrawCanvas/renderOption 默认值
        // drawOption: {},
        // 非必传 按钮配置 传入icon信息 以及 按钮文案信息 不传则用默认值
        btnConfig: this.shapeType === 1 ? null : {
          draw: {
            isShow: true,
            icon: 'scene-canvas_tool-icon scene-canvas_pencil',
            text: this.$t('sceneCard.lightTripCanvasDraw'),
            onclick: () => {},
            callBack: () => {}
          },
          edit: {
            icon: 'scene-canvas_tool-icon scene-canvas_edit',
            text: this.$t('sceneCard.lightTripCanvasEdit'),
          },
          delete: {
            icon: 'scene-canvas_tool-icon scene-canvas_delete',
            text: this.$t('sceneCard.lightTripCanvasDelete'),
          },
          deleteLast: {
            icon: 'scene-canvas_tool-icon scene-canvas_back',
            text: this.$t('sceneCard.lightTripCanvasBack'),
          },
          isSlash: {
            icon: 'scene-canvas_tool-icon scene-canvas_back',
            text: this.$t('sceneCard.lightTripRightAngle')
          }
        },
        // 非必传 线圈点击后高亮回调 可以用于触发当前设备图层回调
        onActive: (VDeviceId) => {
          this.$emit('onDeviceActive', VDeviceId)
        },

        // 非必传 初始化后的钩子
        onReady: () => {
          if (!this.isAlive || this.drawCanvasInstance !== drawCanvasInstance) return;

          onReady && onReady();
          this.$emit('canvasReady', drawCanvasInstance);
          if (this.firstDeviceId) {
            drawCanvasInstance.setCurLineLayerIndex(this.firstDeviceId);
            this.firstDeviceId = null;
          }
        }
      });

      this.drawCanvasInstance = drawCanvasInstance;
    },

    setCurLineLayerIndex(deviceId) {
      if (this.drawCanvasInstance) {
        this.drawCanvasInstance.setCurLineLayerIndex(deviceId);
      } else {
        this.firstDeviceId = deviceId;
      }
    },

    async onImageChange(file) {
      debugger
      if (this.localImageUrl) {
        URL.revokeObjectURL(this.localImageUrl);
      }

      const url = URL.createObjectURL(file.raw);
      this.localImageUrl = url;

      const img = await loadAsyncImg(url);

      const { width, height } = img;
      if (this.shapeType === 1 && (width !== 1000 || height !== 1000)) {
        this.$message.error(
          `${this.$t('visual.uploadImg')}${this.$t('sceneCard.size')}1000 x 1000`
        );

        return;
      }

      if (file.size > 3 * 1024 * 1024) {
        this.$message.error(`${this.$t('visual.uploadImg')}${this.$t('lastLight.lessthan')}3M`)

        return;
      }

      const formData = new FormData();

      formData.append("file", file.raw);

      // ========
      // this.createDrawCanvas(img, null, () => {    
      //   const mapIds = this.checkDeviceList.map(item => ({
      //       mapId: item.VDeviceId
      //     })) 

      //   this.drawCanvasInstance.createRandomLine(mapIds);
      //   this.drawCanvasInstance.divideEqually();
      // });

      // this.$emit('imgUpdate', {
      //   drawCanvasInstance: this.drawCanvasInstance,
      //   bgUrl: url
      // });

      // this.imageUrl = url;

      // return
      // ========

      UploadFile(formData, (res) => {
        debugger
        if (!this.isAlive) return;

        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const cdnUrl = res.Result.RootPath + res.Result.FilePath;
          this.imageUrl = cdnUrl;
          this.activeBgIndex = -1;

          // 推荐图列表未返回或为空时画布尚未创建，不能直接 changeBg
          if (this.drawCanvasInstance) {
            this.drawCanvasInstance.changeBg({
              originImgData: img
            });
          } else {
            this.createDrawCanvas(img, {
              bg: { url: cdnUrl }
            });
          }

          this.$emit('imgUpdate', {
            drawCanvasInstance: this.drawCanvasInstance,
            bgUrl: cdnUrl
          });

          if (this.localImageUrl === url) {
            URL.revokeObjectURL(url);
            this.localImageUrl = '';
          }
        }
      });
    },

    addLamp(vDeviceId, lampCount, lampInfoList) {
      if (!this.drawCanvasInstance) return;

      // 高亮设备 做渲染
      this.drawCanvasInstance.setCurLineLayerIndex(vDeviceId);
      // 增加灯泡 且不渲染
      this.drawCanvasInstance.addLamp(lampCount, { list: lampInfoList, vDeviceId: vDeviceId });
    },

    getColors() {
      if (!this.drawCanvasInstance) return;
  
      const colors = this.drawCanvasInstance.getColors();

      return colors;
    },

    getColors2() {
      if (!this.drawCanvasInstance) return;
      const colors = this.drawCanvasInstance.getColors();
      const m = document.createElement('div');

      Object.values(colors).forEach(list => {
        list.forEach((item, i) => {
          const c = `rgb(${item.rgba.replace(/,255$/, '')})`
          // const rgbaList = item.rgba.split(',') || [];

          // const CxCy = DesignCanvas.transRgbToCxCy(
          //   Number(rgbaList[0]), 
          //   Number(rgbaList[1]), 
          //   Number(rgbaList[2])
          // );

          // console.log('CxCy', i, c, CxCy, `${Number(255).toString(16)}${CxCy}`);

          const d = document.createElement('div');
          d.style = `width:20px;height:20px;margin-left:10px;border:1px solid #333;float:left;background:${c}`;
          m.append(d)
        })
        const d = document.createElement('div');
          d.style = `width:5px;height:20px;margin-left:10px;float:left;background:#222;`;
          m.append(d)
      })
      
      document.querySelector('.upload-preview_title').appendChild(m);
    },

    getSave() {
      if (!this.drawCanvasInstance) return;

      const data = this.drawCanvasInstance.getSaveData();
      console.log('saveData', data);

      localStorage.setItem('testCanvas', JSON.stringify(data));
    },

    divideEqually() {
      this.drawCanvasInstance && this.drawCanvasInstance.divideEqually();
    }
  }
};
</script>

<style lang="scss" scoped>
.scene-canvas {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .scene_container {
    // display: flex;
    width: 100%;
    box-sizing: border-box;

    &_info {
      width: 100%;
      padding: 10px 20px;
      background-color: #F4F5F8;
      color: #8C8C8C;
    }
  }
  .scene_container_preview {
    flex: 1;
  }

  #preview_canvas {
    width: 100%;
    margin-top: 20px;
    // border: 1px solid #eee;
    background: url(../../../../components/DrawCanvas/assets/psBg.png) repeat;
    background-size: 40px 40px;

    &.preview_canvas-shapeType-1 {
      height: 1171px;
    }

    &.preview_canvas-shapeType-2 {
      height: 1236px;
    }
  }

  .scene_container_upload {
    display: flex;
    margin-bottom: 60px;
  }

  .scene_container_upload-article {
    display: flex;
    padding-top: 55px;
    padding-left: 20px;
  }

.scene_container_bgRadio {
  margin-top: 20px;
}

.scene_container_bgSelect {
  margin-top: 20px;
}

.scene_container_bgSelect {
  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  li {
    position: relative;
    width: 105px;
    margin-right: 16px;
    margin-bottom: 10px;
    cursor: pointer;

    .scene_container_bgSelect_border {
      display: none;
      position: absolute;
      width: 95px;
      height: 95px;
      top: -5px;
      left: -5px;
      border: 10px solid #2589FF;
      &.shape-1 {

      }
      &.shape-2 {
        border-radius: 0;
      }
      &.active {
        display: block;
      }
    }

    img {
      width: 100%;
    }

    p {
      margin-top: 13px;
      text-align: center;
    }
  }
}

.upload_box {
  display: flex;
  width: 238px;
  height: 238px;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  color: #D0D0D0;
  overflow: hidden;

  p {
    margin-top: 10px;
  }
  ::v-deep .el-icon-plus {
    font-size: 80px;
    font-weight: bold;
    
  }

  img {
    max-width: 100%;
  }
}

.avatar-uploader_text {
  width: 180px;
  margin: 0 auto;
}
.scene_container_tip_container {
  width: 350px;
}

.scene_container_tip {
  // margin-top: 30px;
  margin-bottom: 5px;
}

.scene_container_tip-info {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: flex-start;
  height: 60px;
  max-width: 534px;

  li {
    display: flex;
    width: 50%;
    max-width: 267px;
    margin-bottom: 16px;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .scene_container_tip-info_icon {
    display: flex;
    min-width: 86px;
    min-height: 86px;
    max-width: 86px;
    max-height: 86px;
    padding: 6px;
    background: #0B3687;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    color: #fff;
    box-sizing: border-box;
    // white-space: nowrap;
    text-align: center;
    .scene-canvas_tool-icon {
      width: 30px;
      height: 30px;
    }
    p {
      width: 100%;
      margin-top: 4px;
      font-size: 12px;
    }
   
  }

  .scene_container_tip-info_text {
    display: flex;
    width: 220px;
    margin-left: 15px;
  }
}

}
</style>

<style lang="scss">
.scene-canvas_tool-icon{
  display: block;
  width: 25px;
  height: 25px;
  margin: 0 auto;
}

.scene-canvas_pencil {
  background: url("~@/assets/img/visual/tool-pencil.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_edit {
  background: url("~@/assets/img/visual/edit.png") no-repeat 0 0 / 100%
    100%;
}

.scene-canvas_delete {
  background: url("~@/assets/img/visual/delete.png") no-repeat 0 0 / 100%
      100%;
}

.scene-canvas_back {
  background: url("~@/assets/img/visual/back.png") no-repeat 0 0 / 100%
      100%;
} 
</style>

